import { FontWeight } from '@quicktools/shared-components';
import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {},
    box: {
      background: '#ffffff',
      borderRadius: 8,
      padding: [72, 24, 120, 24],
      textAlign: 'center',
    },
    icon: {},
    title: {
      fontSize: 16,
      fontWeight: FontWeight.SemiBold,
      lineHeight: '24px',
      color: '#000000',
      marginBottom: 8,
    },
    message: {
      fontSize: 14,
      fontWeight: FontWeight.SemiBold,
      lineHeight: '24px',
      color: '#999999',
    },
    button: {
      background: 'none',
      color: '#5A00EE',
      fontSize: 14,
      fontWeight: FontWeight.SemiBold,
      lineHeight: '24px',
      border: 0,
      outline: 0,
      marginTop: 16,

      '&:hover': {
        cursor: 'pointer',
      },
    },
  },
  { name: 'emojis-zero-results' },
);
